import { ResetPasswordForm } from 'src/components';

export const ResetPassword = () => {
    return <ResetPasswordForm />;
};
